<template>
  <v-container grid-list-md fill-height v-show="true">
    <v-layout row wrap id="printCarteirinha">
      <div class="flex-container" v-for="dependente in dependenteS4E" :key="`${dependente.Id}`">
        <div v-if="dependente.especieNome == 'Canino'">
          <!-- verso da carteirinha -->
          <div class="page-break" />
          <v-flex xs12 sm12 md12 lg12>
            <v-card width="100%" max-width="350px" class="rounded-card">
              <img src="../Content/images/carteirinhaVerso.jpeg" alt="carteirinha" width="100%">
            </v-card>
          </v-flex>
          <!-- frente da carteirinha -->
          <div class="page-break" />
          <v-flex xs12 sm12 md12 lg12>
            <v-card width="100%" max-width="350px" class="rounded-card">
              <img src="../Content/images/carteirinhaCaoFrente_1.jpeg" alt="carteirinha" width="100%">
              <p v-if="!dependente.imageBase64" class="iconeUpload">
                <v-icon @click="cropImage(dependente.Id)" size="40px">camera_alt</v-icon>
              </p>
              <p v-else>
                <img class="fotoPet" width="101px" :src="dependente.imageBase64" alt="foto" @click="cropImage(dependente.Id)" />
              </p>
              <p class="nomePetValor">{{dependente.Nome.split(' ').slice(0, 2).join(' ').substring(0, 25)}}</p>
              <img src="../Content/images/carteirinhaCaoFrente_2.jpeg" alt="carteirinha" width="100%">
              <p class="numChipValor">{{dependente.CPF}}</p>
              <img src="../Content/images/carteirinhaCaoFrente_3.jpeg" alt="carteirinha" width="100%">
              <p class="planoValor">{{dependente.NomePlano}}</p>
              <img class="bottom-radius" src="../Content/images/carteirinhaCaoFrente_4.jpeg" alt="carteirinha" width="100%">
              <p class="respValor">{{responsavelFinanceiro.Nome.split(' ').slice(0, 2).join(' ')}}</p>
              <p class="respCpfValor">{{responsavelFinanceiro.CPF}}</p>
            </v-card>
          </v-flex>
          <br>
        </div>
        <div v-else>
          <!-- verso da carteirinha -->
          <div class="page-break" />
          <v-flex xs12 sm12 md12 lg12>
            <v-card width="100%" max-width="350px" class="rounded-card">
              <img src="../Content/images/carteirinhaVerso.jpeg" alt="carteirinha" width="100%">
            </v-card>
          </v-flex>
          <v-spacer></v-spacer>
          <!-- frente da carteirinha -->
          <div class="page-break" />
          <v-flex xs12 sm12 md12 lg12>
            <v-card width="100%" max-width="350px" class="rounded-card">
              <img src="../Content/images/carteirinhaGatoFrente_1.jpeg" alt="carteirinha" width="100%">
              <p v-if="!dependente.imageBase64" class="iconeUpload">
                <v-icon @click="cropImage(dependente.Id)" size="40px">camera_alt</v-icon>
              </p>
              <p v-else>
                <img class="fotoPet" width="101px" :src="dependente.imageBase64" alt="foto" @click="cropImage(dependente.Id)" />
              </p>
              <p class="nomePetValor">{{dependente.Nome}}</p>
              <img src="../Content/images/carteirinhaGatoFrente_2.jpeg" alt="carteirinha" width="100%">
              <p class="numChipValor">{{dependente.CPF}}</p>
              <img src="../Content/images/carteirinhaGatoFrente_3.jpeg" alt="carteirinha" width="100%">
              <p class="planoValor">{{dependente.NomePlano}}</p>
              <img class="bottom-radius" src="../Content/images/carteirinhaCaoFrente_4.jpeg" alt="carteirinha" width="100%">
              <p class="respValor">{{responsavelFinanceiro.Nome.split(' ').slice(0, 2).join(' ')}}</p>
              <p class="respCpfValor">{{responsavelFinanceiro.CPF}}</p>
            </v-card>
          </v-flex>
          <br>
          <br>
        </div>
      </div>
    </v-layout>
    <v-dialog v-model="uploadPhoto" max-width="550px" max-height="300px" persistent> 
      <v-card style="border-radius: 10px;">
        <v-container grid-list-md>
          <v-layout row wrap justify-center>
            <v-container fill-height fluid pa-1 justify-center>
              <vue-anka-cropper
                :options="{
                  aspectRatio: 1,
                  closeOnSave: true,
                  cropArea: 'box',
                  croppedHeight: 200,
                  croppedWidth: 200,
                  cropperHeight: false,
                  dropareaMessage: 'Arraste uma imagem aqui ou use o botão abaixo',
                  frameLineDash: [0,0],
                  frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                  handleFillColor: 'rgba(255, 255, 255, 0.2)',
                  handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                  handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                  handleSize: 10,
                  handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                  layoutBreakpoint: 500,
                  maxCropperHeight: 768,
                  maxFileSize: 8000000,
                  overlayFill: 'rgba(0, 0, 0, 0.5)',
                  previewOnDrag: false,
                  previewQuality: 0.65,
                  resultQuality: 0.8,
                  resultMimeType: 'image/jpeg',
                  selectButtonLabel: 'Escolher imagem',
                  showPreview: false,
                  skin: 'light',
                  uploadData: {},
                  uploadTo: false
                }"
                @cropper-error="erroCorte($event)"
                @cropper-saved="salvarCorte($event)"
                @cropper-cancelled="cancelaCorte()"
              ></vue-anka-cropper>
            </v-container>
          </v-layout>
          <v-card-actions>
            <v-container fill-height fluid pa-1 justify-center>
              <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="uploadPhoto = false">Fechar</v-btn>
            </v-container>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <Loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#8395A7"
      :is-full-page="fullPage"
    ></Loading>
  </v-container>
</template>

<script>
  import PH from 'print-html-element'
  import axios from 'axios'
  import { baseApiUrl } from '@/global'
  import vueAnkaCropper from 'vue-anka-cropper'
  import Snackbar from '../components/snackbar.vue'
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    components: {vueAnkaCropper, Snackbar, Loading},
    data () {
      return {
        depSelecionado: '',
        uploadPhoto: false,
        nomeUsuario: '',
        planoSelecionado: [],
        isLoading: false,
        fullPage: true,
        financialManagers: {
          contratanteTitular: true,
          confirmPassword: '',
          password: '',
          rg: '',
          rgEmitter: '',
          homePhone: '',
          cellPhone: '',
          cellPhone2: '',
          email: '',
          cep: '',
          address: '',
          addressType: '',
          addressTypeName: '',
          addressNumber: '',
          addressComplement: '',
          district: '',
          city: '',
          state: '',
          proposalNumber: 0,
          contractNumberS4: '',
          responsibility: '',
          cardNumber: '',
          cardValidity: '',
          cardFlag: '',
          cardDayExpiration: 15,
          dateSignatureContract: '',
          formOfPaymentId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: null,
          maritalStatus: null,
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: '',
          nsu: '',
          planoSelecionado: [],
          typeFm: 'FISICA',
          protocoloCancelamento: '',
          vendedor: '' 
        },
        bairro: '',
        estado: '',
        cidade: '',
        nomeVendedor: '',
        titular: {
          parentage: '',
          valuePlan: '',
          lackOfCare: 1,
          rcaId: '',
          dateFirstPayment: '',
          isHolder: '',
          financialManagerId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: '',
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: ''
        },
        dependentes: [{
          parentage: '',
          valuePlan: '',
          lackOfCare: 1,
          rcaId: '',
          dateFirstPayment: '',
          isHolder: '',
          financialManagerId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: '',
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: ''
        }],
        dependenteS4E: [],
        responsavelFinanceiro: [],
        events: [],
      }
    },

    computed: {
      imageHeight() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '220px'
          case 'sm': return '400px'
          case 'md': return '500px'
          case 'lg': return '600px'
          case 'xl': return '800px'
        }
        return true
      },
    },

    mounted : function() {
      if(localStorage.getItem('proposta') != null)
        this.financialManagers = JSON.parse(localStorage.getItem('proposta'))
      this.carregaBeneficiarios() 
      this.carregaPlano() 
      this.carregaDados(null)
    },

    methods: {
      cropImage(depId) {
        this.uploadPhoto = true
        this.depSelecionado = depId
      },

      cancelaCorte() {
        this.uploadPhoto = false
      },

      async salvarCorte(event) {
        this.isLoading = true
        this.events = []
        this.events.unshift({payload: event})
        let fotoDependente = {
          codeS4: this.depSelecionado,
          imageBase64: event.croppedImageURI,
          contractS4: this.responsavelFinanceiro.Id
        }
        for (let i = 0; i < this.dependenteS4E.length; i++) {
          if (this.depSelecionado == this.dependenteS4E[i].Id) {
            if (this.dependenteS4E[i].idImageBase64) {
              fotoDependente.id = this.dependenteS4E[i].idImageBase64
            }
          }
        }
        try {
          await axios.post(`${baseApiUrl}FotoDependentes/replaceOrCreate`, fotoDependente).then(res => {
            if (res.data) {
              this.carregaDados(function () {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#87F500","Imagem salva!","SUCESSO");
                this.uploadPhoto = false
                this.isLoading = false
              }.bind(this))
            }
          })
        } catch (error) {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao salvar a imagem","DESCULPE");
        }
      },

      erroCorte (event) {
        this.events = []
        this.events.unshift({payload: event})
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350","Ocorreu um erro durante a edição da imagem" + event,"DESCULPE");
      },

      print() {
        var opts = {
          /* stylesheets:"<link rel='stylesheet' href='../Content/styles/minify/main.min.css'>", */
          pageTitle: "Carteirinha do(s) Pet(s)"
        }
        PH.printElement(document.getElementById('printCarteirinha'),opts)
      },

      formatDateBrz (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      async carregaBeneficiarios() {
        await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.financialManagers.id})
        .then(response => {
          if (response.data) {
            let titular = response.data.dependentes.filter(dependente => dependente.isHolder == true)
            this.titular = titular
            this.dependentes = response.data.dependentes.filter(dependente => dependente.isHolder == false)
          }
        })
      },

      async carregaDados(callback = null) {
        this.isLoading = true
        await axios.post(`${baseApiUrl}APIS4s/Associados`, {"id": this.financialManagers.codeSaveS4Contract, "incluirDependentes": 1}).then(res => {
          if (res.data) {
            axios.get(`${baseApiUrl}FotoDependentes?filter[where][contractS4]=${res.data.Data[0].Id.toString()}`).then(res2 => {
              if (res2.data) {
                this.dependenteS4E = res.data.Data[0].Dependente
                this.responsavelFinanceiro = res.data.Data[0]
                this.isLoading = false
                for (let i = 0; i < this.dependenteS4E.length; i++) {
                  for (let j = 0; j < res2.data.length; j++) {
                    if (res2.data[j].codeS4 == this.dependenteS4E[i].Id.toString()) {
                      this.dependenteS4E[i].imageBase64 = res2.data[j].imageBase64
                      this.dependenteS4E[i].idImageBase64 = res2.data[j].id
                    }
                  }
                }
                if (callback) {
                  callback()
                }
              }
            })
          }
        })
      },

      async carregaPlano() {
        await axios.post(`${baseApiUrl}FinancialManagers/proposta`, {"id": this.financialManagers.id}).then(async res => {
          let plano = res.data.plano
          await axios.get(`${baseApiUrl}Plans?filter[where][id]=${plano.id}`).then(resp => {
            if (res.data != null) {
              this.planoSelecionado.push(
                resp.data[0].value,
                resp.data[0].area_atuacao,
                resp.data[0].qualificacao,
                resp.data[0].registro,
                resp.data[0].name,
                resp.data[0].cobertura,
                resp.data[0].id,
                "",
                resp.data[0].urlMinutaContrato,
                resp.data[0].urlMinutaAditivo,
                resp.data[0].urlManual,
                resp.data[0].urlGuia,
                resp.data[0].urlCobertura
              )
            }            
          })
        })
      },

    }
  }
</script>

<style>
  .tituloProposta{
    font-size:15px;
    font-weight:700;
    color:#797a7a;
    margin-bottom:5px;  
    text-align: center;  
    border: 1px solid; 
    border-color: #004899;
    border-radius: 10px;
    padding: 8px;
  }

  .item {
    margin: 10px auto;
    font-size:18px;
    color: #004899;
  }

  .itemValor {
    margin: 5px auto;
    font-size:15px;
    color:#797a7a;
  }

  .flex-container {
    display: flex;
    flex-wrap: nowrap;
  }

  .flex-container > div {
    min-width: auto;
    margin: 5px 20px auto auto;
    font-size:15px;
    color:#797a7a;
  }

  .rounded-card {
    border-radius: 25px;
    line-height: 0;
  }

  .nomePetValor {
    margin: 5px auto;
    font-size:15px;
    color:#797a7a;
    position: absolute;
    top: 87px;
    margin-left: 145px;
  }

  .iconeUpload {
    margin: 5px auto;
    font-size: 15px;
    color: #797a7a;
    position: absolute;
    top: 70px;
    margin-left: 60px;
  }

  .fotoPet {
    margin: 5px auto;
    font-size: 15px;
    color: #797a7a;
    position: absolute;
    top: 33px;
    margin-left: 27px;
    border-radius: 8px;
    cursor: pointer
  }

  .numChipValor {
    margin: 5px auto;
    font-size:15px;
    color:#797a7a;
    position: absolute;
    top: 125px;
    margin-left: 145px;
  }

  .planoValor {
    margin: 5px auto;
    font-size:15px;
    color:#797a7a;
    position: absolute;
    top: 162px;
    margin-left: 145px;
  }

  .respValor {
    margin: 5px auto;
    font-size:15px;
    color:#797a7a;
    position: absolute;
    bottom: 20px;
    margin-left: 35px;
  }

  .respCpfValor {
    margin: 5px auto;
    font-size:14px;
    color:#797a7a;
    position: absolute;
    bottom: 20px;
    margin-left: 228px;
  }

  .bottom-radius {
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
  }

  @media screen and (max-width: 394px) {
    .nomePetValor {
      top: 85px;
      margin-left: 140px;
    }
    .planoValor {
      top: 156px;
      margin-left: 140px;
    }
    .respCpfValor {
      margin-left: 223px;
      bottom: 18px;
    }
  }

  @media screen and (max-width: 380px) {
    .nomePetValor {
      top: 80px;
      margin-left: 130px;
    }
    .planoValor {
      top: 148px;
      margin-left: 130px;
    }
    .respCpfValor {
      bottom: 17px;
      margin-left: 209px;
    }
  }

  @media screen and (max-width: 362px) {
    .nomePetValor {
      top: 76px;
      margin-left: 130px;
    }
    .planoValor {
      top: 144px;
      margin-left: 130px;
    }
    .respValor {
      bottom: 17px;
      margin-left: 29px;
    }
    .respCpfValor {
      bottom: 17px;
      margin-left: 200px;
    }
  }

  @media screen and (max-width: 350px) {
    .nomePetValor {
      font-size:13px;
      top: 73px;
      margin-left: 125px;
    }
    .planoValor {
      font-size:13px;
      top: 106px;
      margin-left: 125px;
    }
    .respValor {
      font-size: 13px;
      bottom: 17px;
      margin-left: 29px;
    }
    .respCpfValor {
      font-size:13px;
      bottom: 15px;
      margin-left: 194px;
    }
  }

  @media screen and (max-width: 320px) {
    .nomePetValor {
      font-size: 13px;
      top: 65px;
      margin-left: 110px;
    }
    .planoValor {
      font-size: 13px;
      top: 123px;
      margin-left: 110px;
    }
    .respValor {
      font-size: 13px;
      bottom: 14px;
      margin-left: 29px;
    }
    .respCpfValor {
      font-size: 12px;
      bottom: 15px;
      margin-left: 172px;
    }
  }

  @media all {
    .page-break {
      display: none;
    }
  }

  @media print {
    .page-break {
      margin-top: 1rem;
      display: block;
      page-break-before: auto;
    }
  }

  @import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css'
</style>